module.exports = __webpack_public_path__ + "media/goal.ddef04a5.mp4";